var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRealPerk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2770_33843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.6328C16.8427 33.6328 16.2248 33.3768 15.7599 32.912L12.4763 29.6284H7.83255C7.17527 29.6284 6.5573 29.3724 6.09246 28.9075C5.62762 28.4428 5.37161 27.8249 5.37161 27.1675V22.5237L2.08804 19.2401C1.62319 18.7752 1.36719 18.1573 1.36719 17.5C1.36719 16.8425 1.62319 16.2246 2.08797 15.7599L5.37161 12.4763V7.83255C5.37161 7.17514 5.62762 6.5571 6.09246 6.09226C6.55717 5.62755 7.17514 5.37161 7.83255 5.37161H12.4763L15.7599 2.08804C16.2248 1.62319 16.8427 1.36719 17.5 1.36719C18.1573 1.36719 18.7752 1.62319 19.2401 2.08804L22.5239 5.37161H27.1675C27.8249 5.37161 28.4428 5.62755 28.9075 6.09226C29.3724 6.55696 29.6284 7.17493 29.6284 7.83255V12.4763L32.912 15.7597C33.3768 16.2246 33.6328 16.8426 33.6328 17.5C33.6328 18.1573 33.3768 18.7752 32.912 19.2401L29.6284 22.5237V27.1675C29.6284 27.8249 29.3724 28.4428 28.9076 28.9075C28.4428 29.3724 27.8248 29.6284 27.1675 29.6284H22.5237L19.2401 32.912C18.7752 33.3768 18.1573 33.6328 17.5 33.6328Z",
    stroke: "white",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 21.3669L21.3669 13.6328",
    stroke: "white",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6328,
    cy: 13.6328,
    r: 1.36719,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3672,
    cy: 21.3672,
    r: 1.36719,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2770_33843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRealPerk);
export default __webpack_public_path__ + "static/media/icon-real-perk.c24d069707e2a233b62d2d31c2a5ee7d.svg";
export { ForwardRef as ReactComponent };